module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tip_word"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_vm._v("友情提示：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("1.请按照大V服务平台信息要求填写正确的供应商信息。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("2.所有资质信息格式要求：复印件加盖公司红章之后，再扫描上传到大V服务平台。请确保证件内容清晰可见，扫描件大小不得超过1M。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("3.提交审核之后，大V店工作人员会在3个工作日内进行审核。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("4.入驻过程有任何疑问，请按照如下方式解决："), _c('br'), _vm._v("（1）如果有对接的采销，请直接联系采销处理解决；"), _c('br'), _vm._v("（2）如果还未对接采销，直接发送问题至邮箱：bd@davdian.com 。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("5."), _c('router-link', {
    attrs: {
      "to": "/matters"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#58b7ff"
    }
  }, [_vm._v("点击此处")])]), _vm._v("查看供应商入驻介绍。")], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt20 ovh min_height"
  }, [_c('div', {
    staticClass: "pl10 mt20"
  }, [_c('span', {
    staticClass: "dib"
  }, [_vm._v("合同基本信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [_c('el-form', {
    ref: "agreeform",
    staticClass: "demo-ruleForm mt10",
    attrs: {
      "model": _vm.agreeform,
      "label-width": "207px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "供应商合同编号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreeform.contractCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商编号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreeform.suppliersCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商名称："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreeform.suppliersName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合作方式：",
      "prop": "cooperationType",
      "rules": [{
        required: true,
        message: '请选择合作方式'
      }]
    }
  }, [_c('el-select', {
    attrs: {
      "prop": "cooperationType",
      "placeholder": "请选择合作方式"
    },
    on: {
      "change": function($event) {}
    },
    model: {
      value: (_vm.agreeform.cooperationType),
      callback: function($$v) {
        _vm.$set(_vm.agreeform, "cooperationType", $$v)
      },
      expression: "agreeform.cooperationType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "入仓",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "入仓（实销实结）",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "自发货",
      "value": 3
    }
  })], 1)], 1), _vm._v(" "), (_vm.agreeform.cooperationType == 3) ? _c('el-form-item', {
    attrs: {
      "label": "发货时效："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star92"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-select', {
    staticClass: "ml_10",
    attrs: {
      "placeholder": "请选择发货时效"
    },
    on: {
      "change": function($event) {}
    },
    model: {
      value: (_vm.agreeform.deliveryTime),
      callback: function($$v) {
        _vm.$set(_vm.agreeform, "deliveryTime", $$v)
      },
      expression: "agreeform.deliveryTime"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "48小时",
      "value": 48
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "72小时",
      "value": 72
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同开始时间："
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "请选择合同开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同结束时间："
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "请选择合同结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dib mt10"
  }, [_vm._v("主营品牌信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-table', {
    ref: "agbl",
    staticStyle: {
      "margin": "0 auto",
      "margin-bottom": "22px",
      "margin-top": "22px"
    },
    attrs: {
      "data": _vm.agreeform.applyAgreementBrandList,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "brandName",
      "label": "品牌",
      "width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "合作品类",
      "width": "180",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.categoryLevel.grandName) + "-" + _vm._s(scope.row.categoryLevel.parentName) + "-" + _vm._s(scope.row.categoryLevel.childrenName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否提供发票",
      "align": "center",
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-radio-group', {
          on: {
            "change": function($event) {
              _vm.selProvideInvoice(scope.row, scope.store)
            }
          },
          model: {
            value: (scope.row.provideInvoice),
            callback: function($$v) {
              _vm.$set(scope.row, "provideInvoice", $$v)
            },
            expression: "scope.row.provideInvoice"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": 0
          }
        }, [_c('span', {
          staticClass: "f14 f666"
        }, [_vm._v("否")])]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": 1
          }
        }, [_c('span', {
          staticClass: "f14 f666"
        }, [_vm._v("是")])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发票类型",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "placeholder": "请选择发票类型"
          },
          on: {
            "change": function($event) {
              _vm.selInvoiceType(scope.row)
            }
          },
          model: {
            value: (scope.row.invoiceType),
            callback: function($$v) {
              _vm.$set(scope.row, "invoiceType", $$v)
            },
            expression: "scope.row.invoiceType"
          }
        }, [(_vm.agreeform.registeredCountry == 1) ? _c('el-option', {
          attrs: {
            "label": "增值税普通发票",
            "value": 1
          }
        }) : _vm._e(), _vm._v(" "), (_vm.agreeform.registeredCountry == 1 && _vm.agreeform.taxpayerType == 1) ? _c('el-option', {
          attrs: {
            "label": "增值税专用发票",
            "value": 2
          }
        }) : _vm._e(), _vm._v(" "), (_vm.agreeform.registeredCountry == 1 && _vm.agreeform.taxpayerType == 2) ? _c('el-option', {
          attrs: {
            "label": "增值税专用发票（需去税务局代开）",
            "value": 2
          }
        }) : _vm._e(), _vm._v(" "), (_vm.agreeform.registeredCountry != 1) ? _c('el-option', {
          attrs: {
            "label": "形式发票",
            "value": 3
          }
        }) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "税率",
      "align": "center",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return scope.row.rate != null && scope.row.rate != undefined ? [(_vm.agreeform.taxpayerType == 1 && scope.row.invoiceType == 1) ? _c('el-radio-group', {
          model: {
            value: (scope.row.rate),
            callback: function($$v) {
              _vm.$set(scope.row, "rate", $$v)
            },
            expression: "scope.row.rate"
          }
        }, [_c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "0"
          }
        }, [_vm._v("0%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "6"
          }
        }, [_vm._v("6%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "9"
          }
        }, [_vm._v("9%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "10"
          }
        }, [_vm._v("10%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "13"
          }
        }, [_vm._v("13%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "16"
          }
        }, [_vm._v("16%")])], 1) : _vm._e(), _vm._v(" "), (_vm.agreeform.taxpayerType == 1 && scope.row.invoiceType == 2) ? _c('el-radio-group', {
          model: {
            value: (scope.row.rate),
            callback: function($$v) {
              _vm.$set(scope.row, "rate", $$v)
            },
            expression: "scope.row.rate"
          }
        }, [_c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "6"
          }
        }, [_vm._v("6%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "9"
          }
        }, [_vm._v("9%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "10"
          }
        }, [_vm._v("10%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "13"
          }
        }, [_vm._v("13%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "16"
          }
        }, [_vm._v("16%")])], 1) : _vm._e(), _vm._v(" "), (_vm.agreeform.taxpayerType == 2) ? _c('el-radio-group', {
          model: {
            value: (scope.row.rate),
            callback: function($$v) {
              _vm.$set(scope.row, "rate", $$v)
            },
            expression: "scope.row.rate"
          }
        }, [_c('el-radio', {
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "0"
          }
        }, [_vm._v("0%")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "3"
          }
        }, [_vm._v("3%")])], 1) : _vm._e()] : undefined
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("合同条款-财务信息")]), _c('span', {
    staticClass: "second_line"
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算主体：",
      "prop": "settlementBodyId",
      "rules": [{
        required: true,
        message: '请选择结算主体'
      }]
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticClass: "w193",
          attrs: {
            "placeholder": "请选择结算主体"
          },
          on: {
            "change": function($event) {}
          },
          model: {
            value: (_vm.agreeform.settlementBodyId),
            callback: function($$v) {
              _vm.$set(_vm.agreeform, "settlementBodyId", $$v)
            },
            expression: "agreeform.settlementBodyId"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "北京果敢时代科技有限公司",
            "value": 1
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "MAMA HONG KONG",
            "value": 2
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "天津果敢时代国际贸易有限公司",
            "value": 3
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "正合奇胜（天津）企业咨询管理有限公司",
            "value": 4
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算方式：",
      "prop": "settlementType",
      "rules": [{
        required: true,
        message: '请选择结算方式'
      }]
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticClass: "w193",
          attrs: {
            "placeholder": "请选择结算方式"
          },
          model: {
            value: (_vm.agreeform.settlementType),
            callback: function($$v) {
              _vm.$set(_vm.agreeform, "settlementType", $$v)
            },
            expression: "agreeform.settlementType"
          }
        }, [_c('el-option', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.agreeform.cooperationType == 1),
            expression: "agreeform.cooperationType ==1"
          }],
          attrs: {
            "label": "直采",
            "value": 1
          }
        }), _vm._v(" "), _c('el-option', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.agreeform.cooperationType == 1),
            expression: "agreeform.cooperationType ==1"
          }],
          attrs: {
            "label": "预付款",
            "value": 2
          }
        }), _vm._v(" "), _c('el-option', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.agreeform.cooperationType != 1),
            expression: "agreeform.cooperationType !=1"
          }],
          attrs: {
            "label": "实销实结",
            "value": 3
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算币种："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star92"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "ml_10"
  }, [_vm._v("人民币")])]), _vm._v(" "), (_vm.agreeform.settlementType == 1 || _vm.agreeform.settlementType == 3) ? _c('el-form-item', {
    attrs: {
      "label": "结算账期："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star92"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-select', {
    staticClass: "w193",
    model: {
      value: (_vm.agreeform.settlementPaymentType),
      callback: function($$v) {
        _vm.$set(_vm.agreeform, "settlementPaymentType", $$v)
      },
      expression: "agreeform.settlementPaymentType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "按年结算",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "按半年结算",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "按季度结算",
      "value": 4
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "按月结算",
      "value": 5
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "按半月结算",
      "value": 6
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "自定义",
      "value": 0
    }
  })], 1), _vm._v(" "), (_vm.agreeform.settlementPaymentType === 0) ? _c('el-input', {
    staticClass: "w193",
    attrs: {
      "placeholder": "请输入结算天数"
    },
    model: {
      value: (_vm.agreeform.settlementPaymentDays),
      callback: function($$v) {
        _vm.$set(_vm.agreeform, "settlementPaymentDays", _vm._n($$v))
      },
      expression: "agreeform.settlementPaymentDays"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.agreeform.settlementPaymentType === 0) ? _c('span', [_vm._v("天")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.agreeform.settlementType == 2) ? _c('el-form-item', {
    attrs: {
      "label": "结算账期："
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDomain
    }
  }, [_vm._v("添加分期付款比例")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.agreeform.settlementPaymentRateArr), function(domain, index) {
    return (_vm.agreeform.settlementType == 2) ? _c('el-form-item', {
      key: 'settlementPaymentRate' + index,
      staticClass: "ml60 mt20",
      attrs: {
        "label": '第' + (index + 1) + '期',
        "prop": 'settlementPaymentRateArr' + '[' + index + ']',
        "rules": {
          required: true,
          message: '分期付款比例不能为空',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      staticClass: "w70",
      model: {
        value: (_vm.agreeform.settlementPaymentRateArr[index]),
        callback: function($$v) {
          _vm.$set(_vm.agreeform.settlementPaymentRateArr, index, $$v)
        },
        expression: "agreeform.settlementPaymentRateArr[index]"
      }
    }), _vm._v("\n                        %\n\n\n\n                        "), _c('el-button', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeDomain(domain)
        }
      }
    }, [_vm._v("删除")])], 1) : _vm._e()
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否需要保证金："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star133"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-radio-group', {
    staticClass: "ml_10",
    on: {
      "change": function($event) {}
    },
    model: {
      value: (_vm.agreeform.shouldDeposit),
      callback: function($$v) {
        _vm.$set(_vm.agreeform, "shouldDeposit", $$v)
      },
      expression: "agreeform.shouldDeposit"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("供应商无需交保证金")])]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("供应商需交保证金")])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "保证金："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star78"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "ml_10"
  }, [_vm._v(_vm._s(_vm.agreeform.deposit) + " 人民币")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "货款支付方式："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star120"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "ml_10"
  }, [_vm._v("甲方将货款直接支付到乙方的如下银行账户")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户银行："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star92"
  }, [_vm._v("*")]), _c('span', {
    staticClass: "ml_10"
  }, [_vm._v(_vm._s(_vm.agreeform.bankName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行账号："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star92"
  }, [_vm._v("*")]), _c('span', {
    staticClass: "ml_10"
  }, [_vm._v(_vm._s(_vm.agreeform.accountNumber))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行户名："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star92"
  }, [_vm._v("*")]), _c('span', {
    staticClass: "ml_10"
  }, [_vm._v(_vm._s(_vm.agreeform.accountName))])]), _vm._v(" "), (_vm.agreeform.registeredCountry != 1) ? _c('el-form-item', {
    attrs: {
      "label": "SwiftCode："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star99"
  }, [_vm._v("*")]), _c('span', {
    staticClass: "ml_10"
  }, [_vm._v(_vm._s(_vm.agreeform.swiftCode))])]) : _vm._e(), _vm._v(" "), (_vm.agreeform.registeredCountry == 1) ? _c('el-form-item', {
    attrs: {
      "label": "省："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star50"
  }, [_vm._v("*")]), _c('span', {
    staticClass: "ml_10"
  }, [_vm._v(_vm._s(_vm.agreeform.province))])]) : _vm._e(), _vm._v(" "), (_vm.agreeform.registeredCountry == 1) ? _c('el-form-item', {
    attrs: {
      "label": "市："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star50"
  }, [_vm._v("*")]), _c('span', {
    staticClass: "ml_10"
  }, [_vm._v(_vm._s(_vm.agreeform.city))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("线上合同信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', [_c('el-button', {
    staticClass: "ml115 mt20",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.selectAgree
    }
  }, [_vm._v("选择线上合同")]), _vm._v(" "), _c('span', {
    staticClass: "main_word"
  }, [_vm._v(" （请为供应商选择合同，之后直接在线上完成合同相关信息填写）")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "150px",
      "margin-top": "20px"
    }
  }, _vm._l((_vm.templateContents), function(val) {
    return _c('div', {
      staticClass: "agree_wrap"
    }, [_c('div', {
      staticClass: "in_block"
    }, [_c('span', {
      staticClass: "agree"
    }, [_vm._v(_vm._s(val.name))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.editAgree(val)
        }
      }
    }, [_vm._v("编辑")])], 1)])
  })), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "合同线上模板",
      "visible": _vm.agreeDialog,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.agreeDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "clearfix container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.list), function(val) {
    return _c('div', {
      staticClass: "col-lg-3",
      staticStyle: {
        "width": "20%"
      }
    }, [_c('el-radio-group', {
      on: {
        "change": _vm.argeenSel
      },
      model: {
        value: (_vm.fatherId),
        callback: function($$v) {
          _vm.fatherId = $$v
        },
        expression: "fatherId"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": val.id
      }
    }, [_c('span', {
      staticClass: "f16 fwb"
    }, [_vm._v(_vm._s(val.name))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "mt20"
    }, [_vm._l((val.subList), function(va) {
      return [_c('div', {
        staticClass: "mt10"
      }, [_c('el-radio-group', {
        on: {
          "change": _vm.argeenChildrenSel
        },
        model: {
          value: (_vm.childrenId),
          callback: function($$v) {
            _vm.childrenId = $$v
          },
          expression: "childrenId"
        }
      }, [_c('el-radio', {
        attrs: {
          "label": va.id
        }
      }, [_vm._v(_vm._s(va.name))])], 1), _vm._v(" "), _c('br')], 1)]
    })], 2)], 1)
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.agreeDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveAgree
    }
  }, [_vm._v("确认模板")])], 1)]), _vm._v(" "), _c('el-form-item', {
    staticClass: "auto mt10",
    attrs: {
      "label-width": "207px"
    }
  }, [_c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancleSave
    }
  }, [_vm._v("\n                            取消\n\n                        ")]), _vm._v(" "), _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submit('agreeform')
      }
    }
  }, [_vm._v("\n                            保存\n\n                        ")])], 1)], 2)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_top"
  }, [_c('div', {
    staticClass: "edit_tab"
  }, [_vm._v("供应商信息")]), _c('div', {
    staticClass: "edit_tab"
  }, [_vm._v("品牌信息")]), _c('div', {
    staticClass: "edit_tab"
  }, [_vm._v("财务信息")]), _c('div', {
    staticClass: "edit_tab active_tab"
  }, [_vm._v("合同协议")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f7fe212"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/agreement/agreementList_edit.vue
// module id = 525
// module chunks = 0